<template>
  <!-- 自定义 URL 方案链接 -->
  <div>
    <button v-if="!isWechat" @click="openApp(true)">手动打开APP</button>
    <p v-if="isWechat">请点击右上角，在浏览器中打开</p>
    <p>正在尝试打开 App...</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appLink: '', // 动态绑定 href
      isWechat: false, // 是否在微信中
    };
  },
  mounted() {
    // 检查是否在微信中
    this.isWechat = /MicroMessenger/i.test(navigator.userAgent);
    // 尝试唤醒 App
    this.openApp();
  },
  methods: {
    // 获取 URL 参数
    getQueryString(url) {
      const queryString = url.split('?')[1];
      if (!queryString) return {};
      const searchURL = new URLSearchParams(queryString);
      return Object.fromEntries(searchURL.entries());
    },
    openApp(flag = false) {
      // 获取路径参数
      const query = this.getQueryString(window.location.href);
      const {page = '', data = {}} = query; // 默认参数

      console.log(query);

      if (page && Object.keys(data).length > 0) {
        // 设置自定义 URL Scheme，带参数
        this.appLink = `ankh://abc?page=${page}&data=${data}`;
      } else if (page) {
        // 设置自定义 URL Scheme，不带参数
        this.appLink = `ankh://abc?page=${page}`;
      } else {
        // 设置自定义 URL Scheme，不带参数
        this.appLink = `ankh://abc`;
      }

      // 尝试打开 App
      window.location.href = this.appLink;

      if (!flag) return;

      // 检测是否跳转失败（未安装 App）
      setTimeout(() => {
        // 如果 1 秒后还在当前页面，说明跳转失败
        if (document.visibilityState === 'visible') {
          if (this.isWechat) {
            alert('请在浏览器中打开以使用 App');
          } else {
            window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=uni.UNI53EE4F4'; // 下载地址
          }
        }
      }, 1000);
    },
  },
};
</script>

<style>
p {
  text-align: center;
  margin-top: 20px;
}
</style>